import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../../components/Logo";
import { adminApi, setToken } from "../../lib/adminApi";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const field = "w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-white/40 outline-none transition focus:border-gold focus:ring-2 focus:ring-gold/25";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminApi.login(email.trim().toLowerCase(), password);
      setToken(data.access_token);
      toast.success("Welcome back");
      nav("/admin/deals");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5" data-testid="admin-login">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-gold/20 blur-[120px]" />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo variant="light" /></div>
        <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gold text-white"><Lock size={20} /></span>
            <div>
              <h1 className="font-display text-2xl font-semibold text-white">Admin login</h1>
              <p className="text-xs text-white/50">Manage your distress deals</p>
            </div>
          </div>
          <label className="mb-1.5 block text-xs font-medium text-white/60">Email</label>
          <input data-testid="admin-email" type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="info@offplandubai.nl" />
          <label className="mb-1.5 mt-4 block text-xs font-medium text-white/60">Password</label>
          <input data-testid="admin-password" type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-primary mt-6 w-full disabled:opacity-60">
            {loading ? <><Loader2 size={17} className="animate-spin" /> Signing in...</> : "Sign in"}
          </button>
        </form>
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}
